import Aos from "aos";
import React from "react";
import ScrollUp from './components/Scrolls/ScrollUp'
import DrawerContext from "./Context/DrawerContext";
import AnimatedRoutes from "./components/AnimatedRoutes";
import { ContactModalProvider } from "./Context/ContactModalContext";

function App() {
  Aos.init();

  return (
    <>
      <DrawerContext>
        <ContactModalProvider>
          <AnimatedRoutes />
        </ContactModalProvider>
      </DrawerContext>
      <ScrollUp />
    </>
  );
}

export default App;